<div *ngIf="deviceInput.isVisible"
     class="wrapper">

    <mat-slide-toggle
        *ngIf="formControl"
        (change)="onUpdate($event)"
        [checked]="deviceInput.value"
        [disableControl]="!deviceInput.isEnabled"
        [formControl]="formControl">
        <span
            *ngIf="!hideTitle"
            class="break-spaces"
            [title]="deviceInput.displayText">
            {{ deviceInput.displayText }}
        </span>
    </mat-slide-toggle>

</div>
